import { SimpleForm, TextInput, required, maxLength, useUnique, useTranslate } from 'react-admin';
import CustomCreate from '@/components/global/list/CustomCreate.jsx';
import { Grid, Box, Typography } from '@mui/material';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import { noCharactersFromList } from '@/components/global/validators/customValidators.jsx';
import SelectWithIcon from '@/components/global/inputs/SelectWithIcon';
import TagCategoryListManager from '@/components/tagCategory/TagCategoryListManager';
import TagCategoryToolbar from '@/components/global/tags/TagCategoryToolbar';
import { colorChoices } from '@/constants/TagCategoryColorChoices';
import React from 'react';

const TagCategoryCreate = ({ handleClose }) => {
    const translate = useTranslate();
    const unique = useUnique();
    return (
        <CustomCreate handleClose={handleClose}>
            <Grid>
                <Box sx={{ width: '100%', padding: '0px' }}>
                    <Box className='popup-wrapper popup-wrapper-top'>
                        <Box className='popup-box popup-box--header'>
                            <Typography variant='h4'>{translate('forms.labels.tagCategoryName')}</Typography>
                            <Box>
                                <CustomCloseButton onClose={handleClose} />
                            </Box>
                        </Box>
                    </Box>
                    <Box className='popup-wrapper category-form-wrapper'>
                        <SimpleForm
                            resource='tag-category'
                            toolbar={
                                <TagCategoryToolbar
                                    onCancel={handleClose}
                                    cancelLabel={translate('common.cancel')}
                                    saveLabel={translate('forms.labels.tagCategoryCreate')}
                                />
                            }
                        >
                            <Box display='flex' gap='20px' width='100%'>
                                <TextInput
                                    source='name'
                                    className='category-name'
                                    validate={[
                                        required(translate('common.validation.required')),
                                        maxLength(50, translate('common.validation.maxLength', { count: 50 })),
                                        noCharactersFromList('!@#$^*+\\”"\'`|<>,[]{}'),
                                        unique(),
                                    ]}
                                    fullWidth
                                    placeholder={translate('forms.labels.tagCategoryNamePlaceholder')}
                                    label={translate('forms.labels.tagCategoryNameLabel')}
                                    name='name'
                                />
                                <TextInput
                                    source='nameEn'
                                    className='category-name'
                                    validate={[
                                        required(translate('common.validation.required')),
                                        maxLength(50, translate('common.validation.maxLength', { count: 50 })),
                                        noCharactersFromList('!@#$^*+\\”"\'`|<>,[]{}'),
                                        unique(),
                                    ]}
                                    fullWidth
                                    placeholder={translate('forms.labels.tagCategoryNameEnPlaceholder')}
                                    label={translate('forms.labels.tagCategoryNameEnLabel')}
                                    name='nameEn'
                                />
                            </Box>
                            <SelectWithIcon source='color' className='select-with-icon' colorChoices={colorChoices} />
                            <TagCategoryListManager source='tags' />
                        </SimpleForm>
                    </Box>
                </Box>
            </Grid>
        </CustomCreate>
    );
};

export default TagCategoryCreate;
